import { Component, computed, inject, input } from '@angular/core';

import { RegisterComponent } from '../../components/component-lookup';
import { GlobalConstants } from '../../../shared/global-constants';
import { StateService, SubjectType } from '../../services/state.service';

@RegisterComponent('SubjectHeaderComponent')
@Component({
  selector: 'app-subject-header',
  standalone: true,
  imports: [],
  templateUrl: './subject-header.component.html',
  styleUrl: './subject-header.component.scss'
})
export class SubjectHeaderComponent {
  subjectType = input.required<SubjectType>()
  tourId = input<string>();

  protected colors: string[] = GlobalConstants.colors;
  readonly institution = inject(StateService).institution;
  readonly peerName = inject(StateService).peerName;
  readonly subject = computed(() => this.subjectType() == SubjectType.institution ? this.institution().name : this.peerName());
  readonly color = computed(() => this.subjectType() == SubjectType.institution ? this.colors[0] : this.colors[1]);
}
